<template>
    <div v-if="show">
        <v-form ref="form" v-model="validForm" lazy-validation>
            <v-row>
                <!-- Start Table Solutions -->
                <v-data-table :headers="headers" :items="list" :items-per-page="12" class="elevation-1"
                    style="width: 100%">
                    <template v-slot:top>
                        <v-toolbar flat class="rounded-lg mt-5">
                            <v-toolbar-title><h3>Movimentações</h3></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="disabled" title="Nova Movimentação" outlined class="mb-2" style="color: #FFF; background: #005B8F" text @click="() => create()">
                                <v-icon>add</v-icon> 
                            </v-btn>
                        </v-toolbar>
                    </template>

                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="movement, index in items" :key="index">
                                <td style="font-size: 17px;">
                                    <span>{{mapMessage(movement.movementType, movementType)}}</span>
                                </td>
                                <td :title="movement.createdByName" style="font-size: 17px; cursor: default;">
                                    <span>  </span>
                                    {{truncateText(movement.createdByName, 30)}}
                                </td>
                                <td style="font-size: 17px;">
                                    <span> {{truncateText(movement.observations)}} </span>
                                </td>
                                <td style="font-size: 17px;">
                                    <span> {{formatDateTime(movement.createdAt)}} </span>
                                </td>
                                <td style="font-size: 17px; ">
                                    <span>{{formatDateTime(movement.updatedAt)}}</span>
                                </td>
                                
                                <td>
                                    <v-btn elevation="2" @click="openObservationDialog(movement)"
                                    style="height: 30px; margin: 2px" :disabled="disabled" :loading="loading" v-if="movement.observations !== null && movement.observations.length > 10">
                                        <v-icon color="primary" small>
                                        mdi-note-search
                                        </v-icon>
                                    </v-btn>
                                    <v-btn elevation="2" @click="() => edit(index)" :disabled="disabled"
                                        style="height: 30px; margin: 2px" :loading="loading">
                                        <v-icon color="primary" small> mdi-pencil </v-icon>
                                    </v-btn>
                                    <v-btn elevation="2" @click="() => confirmDeleteMovement(movement, index)"
                                        style="height: 30px; margin: 2px" :disabled="disabled || isFranchisee" :loading="loading"
                                        >
                                        <v-icon color="primary" small> mdi-delete </v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                        
                    </template>
                </v-data-table>
                <!-- End Table Solutions -->
            </v-row>
            <v-dialog transition="dialog-top-transition" v-model="dialog" v-if="dialog" persistent max-width="800px">
                <v-card>
                    <v-toolbar color="primary" dark> <span class="text-h5">{{ movementModalTitle() }}</span></v-toolbar>
                    <v-card-title>
                        Dados da Movimentação
                    </v-card-title>
                    <v-card-text style="padding-bottom: 0px;">
                        <v-row cols="6" dense>
                            <v-col cols="4">
                                <v-select :rules="rulesRequired" label="Tipo de Movimentação *" :loading="loading" :items="movementType" outlined v-model="movement.movementType"></v-select>
                            </v-col>

                            <v-col cols="4" v-if="isDelivery">
                                <v-text-field :rules="rulesRequired" label="Data de Envio *" outlined v-model="movement.deliveryDate"
                                :loading="loading" :disabled="loading" @input="onInputDate"
                                @keypress="onKeyPressDate" maxlength="16" />
                            </v-col>
                            
                            <v-col cols="4" v-if="isDelivery">
                                <v-text-field :rules="rulesRequired" :loading="loading" :disable="loading"
                                label="Site de Rastreio *" outlined type="site" v-model="movement.carrierSite" />
                            </v-col>
                        </v-row>

                        <v-row cols="6" dense>
                            <v-col v-if="isDelivery">
                                <v-text-field :rules="rulesRequired" :loading="loading" :disable="loading"
                                    label="Transportadora *" outlined type="text" v-model="movement.carrierName" />
                            </v-col>
                            <v-col v-if="isDelivery">
                                <v-text-field :rules="rulesRequired" :loading="loading"  :disable="loading"
                                    label="Código de Rastreio *" outlined type="text"
                                    v-model="movement.trackingCode" />
                            </v-col>
                        </v-row>
                        
                        <v-row cols="12">
                                <v-textarea :loading="loading" :disable="loading"
                                label="Observações" outlined v-model="movement.observations" max-rows="2" no-resize/>
                        </v-row>
                </v-card-text>
                <v-divider class="w-100 border-opacity-100"  />
                <v-card-title>
                        Arquivos
                </v-card-title>
                
                <v-card-text>
                    <v-col cols="12">
                            <div>
                                <v-btn @click="addInput" color="primary" class="mb-4 mt-4">+
                                    Adicionar Arquivo</v-btn>
                                <div style="display: flex; overflow-x: scroll;">
                                    <v-col cols="5" v-for="(file, index) in documentsFiles" :key="index">
                                        <v-btn style="margin-left: 10px"
                                            @click="removeInput(index)" color="error" small>
                                            Excluir
                                        </v-btn>
                                        <InputFiles :loading="loading" title=" "
                                            :fileTypes="['pdf', 'image']" :disabled="loading"
                                            :showFile="file"
                                            @change:file="updateFile(index, $event)" />

                                    </v-col>
                                </div>
                            </div>
                        </v-col>
                </v-card-text>

                    <v-card-actions style="position: sticky; bottom: 0; background: white; z-index: 10;">
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="() => closeDialog()" :loading="loading"
                            :disaled="loading">
                            Cancelar
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="() => save()" :loading="loading" :disaled="loading">
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>
        <v-col cols="auto">
            <v-dialog
            v-model="obsDialog"
            transition="dialog-top-transition"
            max-width="600">
                <v-card>
                    <v-toolbar
                    color="primary"
                    dark
                    > Observação </v-toolbar>
                    <v-card-text>
                    <v-col>
                        {{ itemsDialog.observations }}
                    </v-col>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                    <v-btn
                        text
                        @click="obsDialog = false"
                    >Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </div>
</template>

<script>

import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import InputFiles from "@/components/Forms/Input/input-files.vue";
import { mapGetters } from "vuex";
import MaterialsStorage from "@/services/storage/MaterialsStorage.js"
import cloneDeep from 'lodash/cloneDeep';


import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';

const newMovement = () => {
    return {
        movementType: "delivery",
        createdById: null,
        createdByName: null,
        observations: null,
        createdAt: new Date(),
        updatedAt: new Date(),
        documentsFilesPaths: [],
    }
}

export default {
    name: "MaterialList",

    components: {
        InputFiles
    },

    props: {
        show: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (hydrometer, index) => { }
        },
        remove: {
            type: Function,
            default: (index) => { }
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        idMaterials: {
            type: String,
            default: null,
            required: true,
        }
    },

    data: () => ({
        validForm: true,
        dialog: false,
        obsDialog: false,
        loading: false,
        index: -1,
        movement: newMovement(),
        documentsFiles: [],
        itemsDialog: {observations: ""},
        invoiceFile: null,
        movementType: [
            {text: "Envio", value: "delivery"},
            {text: "Recebimento", value: "receiving"},
            {text: "Outros", value: "others"},
        ],
        headers: [
            { text: "Tipo de Movimentação", value: "movementType", width: 250 },
            { text: "Criado Por", value: "createdByName", width: 250},
            { text: "Observações", value: "observations", width: 200,},
            { text: "Criado em", value: "createdAt", width: 200, },
            { text: "Editado Em", value: "updatedAt", width: 200 },
            { text: "Ações ", value: "action"},
        ],
    }),

    computed: {
        ...mapGetters([
            "getCurrentUser",
            "getCurrentUserRank",
        ]),
        rulesRequired() {
            return Rules.required();
        },
        isFranchisee() {
            return this.getCurrentUserRank === "Franqueado";
        },
        isDelivery() {
            return this.movement.movementType === 'delivery';
        },
        isReceiving() {
            return this.movement.movementType === 'receiving';
        }
    },

    methods: {
        async runDeleteImagesFromFirebase(paths) {
            await Promise.all(
                paths.map(MaterialsStorage.deleteImg)
            );
        },
        async checkIfExistsImagesToSave(idMaterial, arrayPath, file) {
            const allowedTypes = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
            const uploadMethod = allowedTypes.includes(file.type)
                ? MaterialsStorage.uploadFile
                : MaterialsStorage.uploadImg;

            return uploadMethod(idMaterial, file, arrayPath);
        },
        async handleImagesOnMaterials() {

            if (this.movement.documentsFilesPaths.length > 0) {
                await this.runDeleteImagesFromFirebase(this.movement.documentsFilesPaths);
            }

            this.movement.documentsFilesPaths = await Promise.all(
                this.documentsFiles.map((file) => {
                    return this.checkIfExistsImagesToSave(this.idMaterials, 'movements', file);
                })
            );

            delete this.movement.documentsFiles
        },
        async downloadImagesFromPath(){
            if (this.movement.documentsFilesPaths.length > 0) {
                this.documentsFiles = (
                    await Promise.all(
                        this.movement.documentsFilesPaths.map(async (path) =>
                            path ? MaterialsStorage.downloadImg(path) : null
                        )
                    )
                ).filter(Boolean);
            } else {
                this.documentsFiles = [];
            }
        },
        movementModalTitle() {
            if (this.index < 0) return "Nova Movimentação"
            else return "Editar Movimentação"
        },
        openObservationDialog(item) {
            this.itemsDialog = item
          this.obsDialog = true
        },
        formatDateTime(date) {
            if (date['seconds'] !== undefined && date['nanoseconds'] !== undefined) {
                return Utils.formatDateDayJs(date['seconds'] * 1000 + date['nanoseconds'] / 1e6, "DD/MM/YYYY [às] HH:mm")
            } else {
                return Utils.formatDateDayJs(new Date(date), "DD/MM/YYYY [às] HH:mm")
            }
        },
        mapMessage(value, list) {
            const mapped = list.find((item) => item.value === value);
            return mapped ? mapped.text : "Não definido"
        },
        addInput() {
          this.documentsFiles.unshift(null);
        },
        updateFile(index, file) {
            if (this.loading) return;

            if (index >= 0 && index < this.documentsFiles.length) {
                if (!file || file === null || file === undefined) {
                    console.warn("Arquivo inválido fornecido para updateFile, definindo como null:", file);
                    this.$set(this.documentsFiles, index, null);
                } else {
                    this.$set(this.documentsFiles, index, file);
                }
            } else {
                console.warn("Índice fora do intervalo para documentsFiles:", index);
            }
        },
        removeInput(index) {
            if (this.documentsFiles.length > 1) {
                this.documentsFiles.splice(index, 1);
            }
        },
        cleanImages() {
            this.documentsFiles = this.documentsFiles.filter(file => file !== null && file !== undefined && file !== '');
        },
        onKeyPressDate(event) {
            const allowedChars = /[0-9:/ ]/;
            if (!allowedChars.test(event.key)) {
            event.preventDefault();
            }
        },
        onInputDate(value) {
            value = value.replace(/[^0-9/: ]/g, "");
        
            if (value.length <= 2) {
            value = value.replace(/^(\d{0,2})/, "$1");
            } else if (value.length <= 5) {
            value = value.replace(/^(\d{2})\/?(\d{0,2})/, "$1/$2");
            } else if (value.length <= 10) {
            value = value.replace(/^(\d{2})\/(\d{2})\/?(\d{0,4})/, "$1/$2/$3");
            } else if (value.length <= 13) {
            value = value.replace(/^(\d{2})\/(\d{2})\/(\d{4})\s?(\d{0,2})/, "$1/$2/$3 $4");
            } else {
            value = value.replace(/^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):?(\d{0,2})/, "$1/$2/$3 $4:$5");
            }
        
            this.movement.deliveryDate = value;
        },
        getFormattedName(fullName) {
                if (!fullName) return '';
                const nameParts = fullName.split(' ');
                if (nameParts.length === 1) {
                    return nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1).toLowerCase();
                }
                const firstName = nameParts[0];
                const lastName = nameParts[nameParts.length - 1];
                return (
                    firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase() + ' ' +
                    lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase()
                );
        },
        truncateText(text, maxLength = 10) {
            if (text !== null && text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        create() {
            this.documentsFiles = [];
            this.index = -1
            this.movement = newMovement()
            this.movement.createdById = this.getCurrentUser.uid
            this.movement.createdByName = `${this.getFormattedName(this.getCurrentUser.data.name)}`
            this.dialog = true
        },
        async edit(index) {
            this.loading = true;
            this.index = index
            this.movement = cloneDeep(this.items[index])
            this.dialog = true
            
            await this.downloadImagesFromPath();
            
            this.loading = false;
            
        },
        async save() {
            this.loading = true;
            if (!this.$refs.form.validate()) {
                this.loading = false;
                return
            }

            this.cleanImages();
            await this.handleImagesOnMaterials();

            this.movement.updatedAt = new Date();
            this.add({ ...this.movement }, this.index)
            this.dialog = false
            this.loading = false
        },
        closeDialog() {
            this.dialog = false
        },
        async confirmDeleteMovement(item, index) {
            showDeleteDialogAlert(`Deseja excluir essa movimentação?`, () => this.remove(item, index))
        },
    },
        async created() {
        },
    watch: {
        list: {
            deep: true,
            handler: function (newValue) {
                if (newValue) {
                    this.items = newValue
                }
            }
        }
    },

};
</script>

<style scoped></style>